import { createContext } from 'react'

const FloorplanContext = createContext(null)

export default FloorplanContext
